import { BrowserRouter, useLocation } from 'react-router-dom';
import { AppRoutes } from './router';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import Nav from '@/pages/home/components/Nav';

function GlobalNav() {
  const location = useLocation();
  // Homepage keeps its full marketing nav. Subpages have their own minimal
  // in-page header (Back + page label).
  if (location.pathname !== '/') return null;
  return <Nav />;
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <GlobalNav />
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;